<template>
  <a-popover placement="bottomLeft" title="添加流程节点" width="350" trigger="click"  v-model="visible">
    <div class="node-select" slot="content">
      <div @click="addApprovalNode" >
        <a-icon type="audit" style="color:var(--main-color);font-size: 25px"/>
        <p>串行执行</p>
      </div>
     
      <div @click="addConcurrentsNode">
        <a-icon type="bars" style="color:var(--main-color);font-size: 25px"/>

        <span>并行执行</span>
      </div>
    
     
    </div>
    <a-button  :size="$globalSize"  icon="plus" type="primary"  shape="circle" ></a-button>
  </a-popover>
</template>

<script>
export default {
  name: "InsertButton",
  components: {},
  data() {
    return {
      visible:false
    }
  },
  computed:{
    selectedNode(){
      this.$store.state.selectedNode
    }
  },
  methods: {
    addApprovalNode(){
      this.$emit('insertNode', "APPROVAL")
      this.visible = false
    },
    addCcNode(){
      this.$emit('insertNode', "CC")
      this.visible = false

    },
    addDelayNode(){
      this.$emit('insertNode', "DELAY")
      this.visible = false

    },
    addConditionsNode(){
      this.$emit('insertNode', "CONDITIONS")
      this.visible = false

    },
    addConcurrentsNode(){
      this.$emit('insertNode', "CONCURRENTS")
      this.visible = false

    },
    addTriggerNode(){
      this.$emit('insertNode', "TRIGGER")
      this.visible = false

    }
  }
}
</script>

<style lang="less" scoped>
.node-select{
  display: flex;
  width: 280px;
  flex-wrap: wrap;
  div{
    margin: 5px 5px;
    cursor: pointer;
    padding: 10px 15px;
    border: 1px solid #F8F9F9;
    background-color: #F8F9F9;
    border-radius: 10px;
    width: 130px;
    display: flex;
    align-items: center;
    grid-gap: 5px;
    p{
      margin: 0;
    }
    &:hover{
      background-color: #fff;
      box-shadow: 0 0 8px 2px #d6d6d6;
    }
  }
}
</style>
